const actionTypes = {
    SET_EMAIL: 'SET_EMAIL',
    SET_CODE: 'SET_CODE',
    SEND_ERROR: 'SEND_ERROR',
    LOGOUT: 'LOGOUT',
    SET_DOMAIN: 'SET_DOMAIN'
};

export default actionTypes ;
